import { render, staticRenderFns } from "./employee-notes.vue?vue&type=template&id=45016e10&"
import script from "./employee-notes.vue?vue&type=script&lang=js&"
export * from "./employee-notes.vue?vue&type=script&lang=js&"
import style0 from "./employee-notes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports